import Cookie from "js-cookie";
import { isBD } from "../../../utils/businessType.lib.js";
import { getIsOneTrustTargetingEnabled } from "../../../utils/oneTrust/oneTrust.lib.js";
import { LEGACY_COOKIE_ONE_TRUST, LEGACY_COOKIE_AKAMAI_ZIP, MAX_COOKIE_EXPIRATION_DAYS, LEGACY_COOKIE_STORE_LOCATION, MAX_STORE_LOCATION_COOKIE_EXPIRATION_DAYS, STORE_LOCATION_RESET_SESSION_STORAGE_FLAG, LEGACY_COOKIE_WAREHOUSE_DELIVERY, MAX_WAREHOUSE_COOKIE_EXPIRATION_DAYS, WAREHOUSE_RESET_SESSION_STORAGE_FLAG, LEGACY_COOKIE_WC_MEMMBER, LEGACY_COOKIE_DELIVERY_LOCATION_CITY, LEGACY_COOKIE_DELIVERY_LOCATION_STATE_CODE, LEGACY_COOKIE_DELIVERY_LOCATION_ZIP_CODE, LEGACY_COOKIE_WC_BD_ZIP, LEGACY_COOKIE_CART_COUNT, LEGACY_COOKIE_WC_CART_ORDER } from "./constants.js";
const warehouse = {
  read: () => {
    const legacyWarehouseCookieContent = Cookie.get(
      LEGACY_COOKIE_WAREHOUSE_DELIVERY
    );
    let value;
    if (legacyWarehouseCookieContent) {
      try {
        value = JSON.parse(
          legacyWarehouseCookieContent
        );
      } catch (err) {
        console.error(`Error reading warehouse cookie: ${err}`);
      }
    }
    return value;
  },
  warehouseCookieExpResetFlag: () => {
    const warehouseCookieFlag = window.sessionStorage.getItem(
      WAREHOUSE_RESET_SESSION_STORAGE_FLAG
    );
    return warehouseCookieFlag ? warehouseCookieFlag : "";
  },
  write: (value) => {
    try {
      const encodedValue = JSON.stringify(value);
      Cookie.set(LEGACY_COOKIE_WAREHOUSE_DELIVERY, encodedValue, {
        expires: MAX_WAREHOUSE_COOKIE_EXPIRATION_DAYS
      });
    } catch (err) {
      console.error(`Error writing warehouse state: ${err}`);
      return;
    }
  }
};
const wc_member = {
  read: () => {
    const cookieContent = Cookie.get(LEGACY_COOKIE_WC_MEMMBER);
    let value;
    if (cookieContent) {
      value = cookieContent;
    }
    return value;
  },
  write: (value) => {
    const cookieContent = value;
    Cookie.set(LEGACY_COOKIE_WC_MEMMBER, cookieContent, {
      expires: MAX_COOKIE_EXPIRATION_DAYS
    });
  }
};
const storeLocation = {
  read: () => {
    const cookieContent = Cookie.get(LEGACY_COOKIE_STORE_LOCATION);
    let value;
    if (cookieContent) {
      try {
        const properties = JSON.parse(
          cookieContent
        );
        value = properties.storeLocation;
      } catch (err) {
        console.error(`Error reading storeLocation: ${err}`);
      }
    }
    return value;
  },
  storeLocCookieExpResetFlag: () => {
    const storeLocCookieFlag = window.sessionStorage.getItem(
      STORE_LOCATION_RESET_SESSION_STORAGE_FLAG
    );
    return storeLocCookieFlag ? storeLocCookieFlag : "";
  },
  write: (value) => {
    const cookieContent = {
      storeLocation: value
    };
    const encodedValue = JSON.stringify(cookieContent);
    Cookie.set(LEGACY_COOKIE_STORE_LOCATION, encodedValue, {
      expires: MAX_STORE_LOCATION_COOKIE_EXPIRATION_DAYS
    });
  }
};
const deliveryLocation = {
  read: () => {
    const cityCookieContent = Cookie.get(
      LEGACY_COOKIE_DELIVERY_LOCATION_CITY
    );
    let city;
    if (cityCookieContent) {
      const decodedValue = cityCookieContent;
      city = decodedValue;
    }
    const stateCookieContent = Cookie.get(
      LEGACY_COOKIE_DELIVERY_LOCATION_STATE_CODE
    );
    let state;
    if (stateCookieContent) {
      const decodedValue = stateCookieContent;
      state = decodedValue;
    }
    const zipCodeCookieContent = Cookie.get(
      LEGACY_COOKIE_DELIVERY_LOCATION_ZIP_CODE
    );
    const bdZipCode = Cookie.get(LEGACY_COOKIE_WC_BD_ZIP);
    let zipCode;
    if (bdZipCode && isBD()) {
      zipCode = bdZipCode;
    } else if (zipCodeCookieContent) {
      const decodedValue = zipCodeCookieContent;
      zipCode = decodedValue;
    }
    return {
      city,
      state,
      zipCode
    };
  },
  write: ({ city = "", state = "", zipCode = "" }) => {
    const encodedCityValue = city;
    Cookie.set(LEGACY_COOKIE_DELIVERY_LOCATION_CITY, encodedCityValue, {
      expires: MAX_COOKIE_EXPIRATION_DAYS
    });
    const encodedStateValue = state;
    Cookie.set(
      LEGACY_COOKIE_DELIVERY_LOCATION_STATE_CODE,
      encodedStateValue,
      {
        expires: MAX_COOKIE_EXPIRATION_DAYS
      }
    );
    const encodedZipCodeValue = zipCode;
    Cookie.set(
      LEGACY_COOKIE_DELIVERY_LOCATION_ZIP_CODE,
      encodedZipCodeValue,
      {
        expires: MAX_COOKIE_EXPIRATION_DAYS
      }
    );
  }
};
const cartCount = {
  read: () => {
    return parseInt(Cookie.get(LEGACY_COOKIE_CART_COUNT) || "0", 10);
  },
  write: (value) => {
    Cookie.set(LEGACY_COOKIE_CART_COUNT, value.toString(), {
      expires: MAX_COOKIE_EXPIRATION_DAYS
    });
  }
};
const akamiZipCode = {
  read: () => {
    const cookieContent = Cookie.get(LEGACY_COOKIE_AKAMAI_ZIP);
    return cookieContent || void 0;
  },
  write: (value) => {
    Cookie.set(LEGACY_COOKIE_AKAMAI_ZIP, value, {
      expires: MAX_COOKIE_EXPIRATION_DAYS
    });
  }
};
const oneTrust = {
  read: () => {
    const cookieContent = Cookie.get(LEGACY_COOKIE_ONE_TRUST);
    if (cookieContent) {
      const parsedCookie = cookieContent.split("&").reduce((acc, part) => {
        const [key, value] = part.split("=");
        acc[key] = value;
        return acc;
      }, {});
      const isTargetingEnabled = parsedCookie.groups ? getIsOneTrustTargetingEnabled(parsedCookie.groups) : false;
      return {
        isTargetingEnabled
      };
    } else {
      return {
        isTargetingEnabled: false
      };
    }
  }
};
const wcCartOrder = {
  read: () => {
    const value = Number(Cookie.get(LEGACY_COOKIE_WC_CART_ORDER));
    const validatedValue = isNaN(value) ? 0 : value;
    return validatedValue;
  },
  write: (value) => {
    const validatedValue = isNaN(value) ? "0" : value.toString();
    Cookie.set(LEGACY_COOKIE_WC_CART_ORDER, validatedValue, {
      expires: MAX_COOKIE_EXPIRATION_DAYS
    });
  }
};
const wcBDZip = {
  read: () => {
    const bdZipCode = Number(Cookie.get(LEGACY_COOKIE_WC_BD_ZIP));
    return bdZipCode;
  },
  write: (value) => {
    Cookie.set(LEGACY_COOKIE_WC_BD_ZIP, value.toString(), {
      expires: MAX_COOKIE_EXPIRATION_DAYS
    });
  }
};
export {
  akamiZipCode,
  cartCount,
  deliveryLocation,
  oneTrust,
  storeLocation,
  warehouse,
  wcBDZip,
  wcCartOrder,
  wc_member
};
